import React from 'react';
export function PainPoints() {
  return <section className="py-16 px-4 bg-gray-50 border-y border-gray-200" data-id="element-135">
      <div className="max-w-3xl mx-auto" data-id="element-136">
        <div className="text-center mb-12" data-id="element-137">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" data-id="element-138">
            Déjame hacerte una pregunta honesta…
          </h2>
          <div className="w-24 h-1 bg-red-600 mx-auto" data-id="element-139"></div>
        </div>

        <div className="space-y-6 text-lg md:text-xl text-gray-700 font-medium mb-12" data-id="element-140">
          <p className="flex items-start" data-id="element-141">
            <span className="text-red-500 mr-3 font-bold text-2xl" data-id="element-142">❌</span>
            ¿Te sientes inflamado/a aunque "no comas tanto"?
          </p>
          <p className="flex items-start" data-id="element-143">
            <span className="text-red-500 mr-3 font-bold text-2xl" data-id="element-144">❌</span>
            ¿Empiezas dietas con motivación… pero a las dos semanas abandonas?
          </p>
          <p className="flex items-start" data-id="element-145">
            <span className="text-red-500 mr-3 font-bold text-2xl" data-id="element-146">❌</span>
            ¿Te gana la ansiedad por la noche?
          </p>
          <p className="flex items-start" data-id="element-147">
            <span className="text-red-500 mr-3 font-bold text-2xl" data-id="element-148">❌</span>
            ¿Sientes que necesitas estructura pero no sabes por dónde empezar?
          </p>
        </div>

        <div className="bg-white p-8 rounded-xl shadow-lg border-l-8 border-red-600 mb-12" data-id="element-149">
          <p className="text-2xl font-bold text-gray-900 mb-4" data-id="element-150">
            No estás solo/a.
          </p>
          <p className="text-xl text-gray-700 mb-2" data-id="element-151">
            No es falta de fuerza de voluntad. No es que "no sirvas para las
            dietas".
          </p>
          <p className="text-xl text-gray-700 font-bold mb-4" data-id="element-152">
            Es que nadie te dio un sistema claro, estructurado y sostenible.
          </p>
          <p className="text-xl text-red-600 font-black italic" data-id="element-153">
            Y sin sistema… todo termina igual.
          </p>
        </div>

        <div className="text-center mb-10" data-id="element-154">
          <h3 className="text-3xl font-black text-gray-900 mb-8" data-id="element-155">
            El problema que nadie te explica
          </h3>
          <p className="text-xl text-gray-700 mb-8" data-id="element-156">
            Si has intentado bajar de peso antes, esto te resultará familiar:
          </p>
        </div>

        <div className="bg-white p-6 md:p-8 rounded-xl shadow-md border border-gray-200" data-id="element-157">
          <ul className="space-y-4 text-lg text-gray-700" data-id="element-158">
            <li className="flex items-center" data-id="element-159">
              <span className="w-2 h-2 bg-red-500 rounded-full mr-4" data-id="element-160"></span>
              Pasas de dieta en dieta
            </li>
            <li className="flex items-center" data-id="element-161">
              <span className="w-2 h-2 bg-red-500 rounded-full mr-4" data-id="element-162"></span>
              Eliminas alimentos y luego los recuperas con culpa
            </li>
            <li className="flex items-center" data-id="element-163">
              <span className="w-2 h-2 bg-red-500 rounded-full mr-4" data-id="element-164"></span>
              Pierdes peso rápido… y lo recuperas más rápido
            </li>
            <li className="flex items-center" data-id="element-165">
              <span className="w-2 h-2 bg-red-500 rounded-full mr-4" data-id="element-166"></span>
              No sabes cómo controlar la ansiedad
            </li>
            <li className="flex items-center" data-id="element-167">
              <span className="w-2 h-2 bg-red-500 rounded-full mr-4" data-id="element-168"></span>
              No tienes una estructura clara
            </li>
            <li className="flex items-center" data-id="element-169">
              <span className="w-2 h-2 bg-red-500 rounded-full mr-4" data-id="element-170"></span>
              Empiezas fuerte… y abandonas a mitad de camino
            </li>
          </ul>
        </div>

        <div className="mt-12 text-center" data-id="element-171">
          <p className="text-2xl font-bold text-gray-900 mb-2" data-id="element-172">
            Lo peor no es el peso.
          </p>
          <p className="text-2xl text-red-600 font-black italic" data-id="element-173">
            Es la sensación constante de: "Empiezo el lunes… otra vez."
          </p>
        </div>
      </div>
    </section>;
}